import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withStore } from 'contexts/store-context';
import { withToast } from 'contexts/toast-context';
import { Link } from 'react-router-dom';
import LoadingIndicator from 'components/loading/loading-indicator';
import FAWrapper from 'components/vendors/fa-wrapper';
import { isEmpty } from 'utils/helpers';
import { LoadingSkeleton } from 'components/loading/loading-skeleton';
import { DropdownWrapper, DropdownMenuWrapper } from 'components/bootstrap/dropdowns';
import { Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal } from 'reactstrap';

const CustomerActions = (props) => {
  const { type = 'detail', customer = {}, provider, history, store, loading, refreshData } = props;
  const [ dropdownOpen, setDropdownOpen ] = useState(false);
  const [ showForm, setShowForm ] = useState(false);
  const [ taskRunning, setTaskRunning ] = useState(false);


	// Methods
	const archiveCustomer = async () => {
    try {
      setTaskRunning(true);
      await customer.destroy();
      type == 'detail' ? history.push(`/admin/${provider.id}/customers`) : refreshData();
    } catch(e) {
      toast.showError(e);
    } finally {
      setTaskRunning(false);
    }
	}


// Render
  return (
    <DropdownWrapper isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
      {type == 'detail' && (
        <DropdownToggle color='primary' size='md'>
          {taskRunning ? <LoadingIndicator color='gray' size='18px'/> : <span>Manage<FAWrapper icon='chevron-down' className='ml-2 sm'/></span>}
        </DropdownToggle>
      )}

      {type == 'table' && (
        <DropdownToggle color='icon-gray'>
          {taskRunning ? <LoadingIndicator color='gray' size='18px'/> : <FAWrapper icon='chevron-down'/>}
        </DropdownToggle>
      )}

      <DropdownMenuWrapper isOpen={dropdownOpen} right={true}>
        <DropdownItem tag='li'>
          <Link className='btn' to={customer.url}>View</Link>
        </DropdownItem>

        <DropdownItem tag='li'>
          <Link className='btn' to={customer.url + '/edit'}>Edit</Link>
        </DropdownItem>

        <DropdownItem tag='li'>
          <Button color='transparent' onClick={() => archiveCustomer()}>Archive</Button>
        </DropdownItem>
      </DropdownMenuWrapper>
    </DropdownWrapper>
  )
}

export default withRouter(withStore(withToast(CustomerActions)));
